module.exports = __webpack_public_path__ + "img/jixiaoziping_pitchon.66a4498b.svg";